import { SimplePointsExchange } from "./PointsExchange";

export const MIN_REDEEMABLE_POINTS = 100;

export const defaultPointsExchange = new SimplePointsExchange({
  currencyCode: "USD",
  currencySymbol: "$",
  value: 0.01,
});
